// ============================================================================
// COUNTRY SERVICE (read-only)
// ============================================================================

import { get } from '../client/axiosClient';
import { countryEndpoints, COUNTRY_BASE_PATH } from '../endpoints/country.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type { ApiResponse, PaginatedResponse, ID } from '../types';
import type {
  Country,
  CountryListItem,
  CountrySearchRequest,
} from '../types/country.types';

class CountryService {
  async getAll(params?: CountrySearchRequest): Promise<PaginatedResponse<CountryListItem>> {
    const endpoint = params
      ? buildEndpointWithQuery(COUNTRY_BASE_PATH, params)
      : countryEndpoints.list();

    const response = await get<any>(endpoint);
    const raw = response.data;
    const pagedResult = raw?.data ?? {};
    return {
      success: raw?.success ?? false,
      message: raw?.message,
      data: pagedResult.items ?? [],
      pagination: {
        currentPage: pagedResult.page ?? 1,
        pageSize: pagedResult.pageSize ?? 20,
        totalPages: pagedResult.totalPages ?? 0,
        totalItems: pagedResult.totalCount ?? 0,
        hasNextPage: pagedResult.hasNext ?? false,
        hasPreviousPage: pagedResult.hasPrevious ?? false,
      },
    };
  }

  async getById(id: ID): Promise<ApiResponse<Country>> {
    const response = await get<ApiResponse<Country>>(countryEndpoints.getById(id));
    return response.data;
  }
}

export const countryService = new CountryService();
export default countryService;
